module.exports = __webpack_public_path__ + "media/images/partners/volnoe-delo-d9b744c70331df61e6c8ff8f442444da.png";